import * as getters from '@/store/modules/credits/myCredits/getters'
import * as mutations from '@/store/modules/credits/myCredits/mutations'
import * as actions from '@/store/modules/credits/myCredits/actions'

const state = {
    accountsList: [],
    financialPlan: [],
    financialPlanList: [],
    financialPlanHasMore: false,
    movements: [],
    lastMovementInfo: {},
    movementsHasMore: false,
    patrimonyAccountList: null
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
